import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendSentryClientErrorOnce } from 'shared/lib';
import type { TLoansFirstTouchClient } from 'shared/types/TLoansService';

import { userDeviceIdSelector } from 'entities/user';

import { sendLoansFirstTouchApi } from '../model/sendLoansFirstTouch.query';

export const sendFirstTouchThunk = createAsyncThunk<
  void,
  Pick<TLoansFirstTouchClient, 'sourceUrl'>,
  { state: Pick<Store, 'user'> }
>('sendLoansFirstTouch/sendLoansFirstTouchThunk', async (payload, { dispatch, getState }) => {
  const { sourceUrl } = payload;
  const deviceId = userDeviceIdSelector(getState());

  try {
    await dispatch(
      sendLoansFirstTouchApi.endpoints.sendLoansFirstTouch.initiate({
        sourceUrl,
        deviceId,
      }),
    ).unwrap();
  } catch (error) {
    sendSentryClientErrorOnce('sendLoansFirstTouchThunk', error);
  }
});
